<aside class="sidebar">
	<div
		class="mt-3 d-flex"
		[ngClass]="{
			'justify-content-center': isSidebardHidden,
			'justify-content-end me-4': !isSidebardHidden
		}"
	>
		<button
			title="Afficher/cacher le menu"
			class="btn nav-link"
			(click)="toggleSidebarPin()"
		>
			<i
				*ngIf="isSidebardHidden"
				class="bi bi-list topbar-blue-button fs-1"
				aria-hidden="true"
			></i>
			<i
				*ngIf="!isSidebardHidden"
				class="bi bi-arrow-left topbar-blue-button fs-2"
				aria-hidden="true"
			></i>
		</button>
	</div>
	<!--
	<div
		class="sidebar-profile d-flex flex-column justify-content-center pt-3 pb-3"
	>
		
		<div class="profile-details text-center pb-4 pt-4">
			<p class="mb-0 text-uppercase name">
				{{ currentUserLoggedIn.employee.firstName }}
				{{ currentUserLoggedIn.employee.lastName }}
			</p>
			<small class="text-uppercase profile">{{
				currentUserLoggedIn.profile.name
			}}</small>
		</div>
	</div>
	-->
	<nav class="sidebar-menu pt-3 pb-3">
		<!-- <div class="menu-header mt-3 mb-2">Components</div> -->
		<ul class="menu-items">
			<!-- <li *ngFor="let menuItem of menuItems">
				<button
					[title]="menuItem.name"
					[routerLink]="[menuItem.path]"
					routerLinkActive="fw-bolder">
					<i [class]="menuItem.iconClass" aria-hidden="true"></i>
					<span class="fs-6">{{ menuItem.name }}</span>
					 <span class="badge badge-warning rounded-0 text-dark p-1">NEW</span> 
				</button>
			</li>  -->

			<li *ngFor="let item of menuItems" #itemEl routerLinkActive="fw-bolder">
				<div *ngIf="item.sub_menu.length == 0" class="dropdown-title">
					<button 
						[title]="item.name"
						[routerLink]="[item.path]"
						routerLinkActive="fw-bolder">
					<i [class]="item.iconClass" aria-hidden="true"></i>
					<span class="fs-6">{{item.name}}</span>
				  </button>
				</div>
				<div *ngIf="item.sub_menu.length > 0" class="dropdown-title" (click)="showHideSubmenu(itemEl)">
					<button
						[title]="item.name"
						routerLinkActive="fw-bolder">
					<i [class]="item.iconClass" aria-hidden="true"></i>
					<span class="fs-6">{{item.name}}</span>
					<i style="display:none; font-size: 1em !important; margin-left : 10px;" class='bi bi-chevron-down'></i>
					<i style="font-size: 1em !important; margin-left : 10px;" class='bi bi-chevron-up'></i>
					</button>		
				</div>
				<ul class="sub-menu" [class.blank]="item.sub_menu.length > 0">
				  <!-- <li><button class="link_name">{{item.name}}</button></li> -->
				  <li *ngFor="let item_sub of item.sub_menu" routerLinkActive="fw-bolder">
					<button [routerLink]="[item_sub.path]">
						<span class="fs-7">{{item_sub.name}}</span></button>
				  </li>
				</ul>
			  </li>
		</ul> 
		
	</nav>
</aside>
